import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';


export default class Glossary extends Component {
    render() {
        return (
            <div>
                <h5 className="glossary-word">Glossary</h5>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">DAB</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Diameter above buttress) Diameter (cm) of the trunk/stem measured immediately above the root buttress. Referred to as ‘D’ and measured in metres in AS 4970-2025.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">DSH</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Diameter at standard height) Diameter (cm) of the trunk/stem measured at 1.4m above ground. For multi stem trees, refer to AS 4970-2025, Appendix A, Figure A1.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">Encroachment</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            Works or change of use (temporary or permanent) proposed to occur within an identified NRZ either above or below ground, regardless of work method or construction type.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">SRZ</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Structural root zone) Theoretical area around the base of a tree required for the tree's stability in the ground.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">NRZ</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Notional root zone) An area enclosed by a radius of 12 times DSH that is a primary trigger for arboricultural input on a development site.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">Work</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            Any physical activity in relation to land that is specified by the relevant authority (e.g. a local council).
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
            </div>
        );
    }
}